// Lib
import { createAction } from 'redux-actions';

export const OpenPopup = createAction('OPEN_POPUP');
export const ClosePopup = createAction('CLOSE_POPUP');
